<template>
  <div class="table-wrapper" unselectable="on">
    !{{this.$store.state.tempRegData}}!
    <LoaderWait v-show="loading"/>
    <table class="main-table">
      <tr>
        <td class="td-logo" width="30%"><img src="/imgs/logo_impay.png"></td>
        <td width="40%" align="center" style="vertical-align: top"><div class="info-text">Регистрация кошелька</div></td>
        <td width="30%"></td>
      </tr>
      <tr>
        <td class="td-row" colspan="3" align="center">
          <div class="input-head-text">{{ fields[step].label || ''}} ({{ step + 1 }} / {{ stepCount }})</div>
        </td>
      </tr>
      <tr>
        <td class="td-row" colspan="3" align="center">
          <div class="fon-input">
            <input type="text" readonly class="input-field" v-model="maskedNumber">
            <img @click="clickBsKey" class="bnt-key-bs" src="/imgs/btn_bs_1.png">
          </div>
        </td>
      </tr>
      <tr v-show="isLiteralKeyboard">
        <td class="td-row" colspan="3" align="center">
          <KeyboardLiteral :on-click="onClickKey"></KeyboardLiteral>
        </td>
      </tr>
      <tr v-show="!isLiteralKeyboard">
        <td class="td-row" width="30%">
          <div style="padding: 10px" v-show="step == 4" @click="switchInn">
            <img :src="this.isSnils ? '/imgs/btn_inn_1.png' : '/imgs/btn_snils_1.png'">
          </div>
        </td>
        <td width="40%" align="center">
          <KeyboardDigital :on-click="onClickKey"></KeyboardDigital>
        </td>
        <td class="td-row-b" width="30%">
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
          <img @click="backClick" id="btn_back" src="/imgs/back_1.png">
        </td>
        <td width="40%" align="center">
          <img @click="mainClick" id="btn_menu" src="/imgs/menu_impay_1.png">
        </td>
        <td width="30%" align="right">
          <img @click="fwdClick" ref="btnFwd" src="/imgs/fwd_1.png">
        </td>
      </tr>
    </table>
    <MessageBox :message="errorMessage" v-show="showMessage" :on-close="messageClose"></MessageBox>
  </div>
</template>

<script>
import LoaderWait from "@/components/LoaderWait.vue";
import KeyboardLiteral from "@/components/KeyboardLiteral.vue";
import KeyboardDigital from "@/components/KeyboardDigital.vue";
import MessageBox from "@/components/MessageBox.vue";
import { formatMask } from "@/utils/format_mask.js";

export default {
  name: "IdentifyPage",
  components: { MessageBox, KeyboardDigital, KeyboardLiteral, LoaderWait },
  data () {
    return {
      loading: false,
      timer: null,
      number: '',
      maskedNumber: '',
      step: 0,
      fields: [
        { label: 'Введите фамилию', maxLength: 50, mask: '', regexp: /.{1,50}/, keyboardLiteral: true },
        { label: 'Введите имя', maxLength: 50, mask: '', regexp: /.{1,50}/, keyboardLiteral: true },
        { label: 'Введите отчество', maxLength: 50, mask: '', regexp: /.{1,50}/, keyboardLiteral: true },
        { label: 'Введите дату рождения', maxLength: 8, mask: '##.##.####', regexp: /(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])\d{4}/, keyboardLiteral: false },
        { label: 'Введите ваш СНИЛC', maxLength: 11, mask: '###-###-### ##', regexp: /\d{11}/, keyboardLiteral: false },
        { label: 'Введите серию и номер паспорта', maxLength: 10, mask: '#### ######', regexp: /\d{10}/, keyboardLiteral: false },
      ],
      inputs: [],
      showMessage: false,
      errorMessage: '',
      messagePromiseResolver: null,
      isSnils: true,
    }
  },
  computed: {
    isLiteralKeyboard() {
      return this.fields[this.step].keyboardLiteral
    },
    user() {
      const data = this.$store.getters.GET_USER_PROFILE
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
    stepCount() {
      return this.fields.length;
    }
  },
  mounted () {
    this.inputs = []
    this.updateTimer()
  },
  methods: {
    updateTimer() {
      this.stopTimer()
      this.timer = setTimeout(() => this.timerExit(), 120000)
    },
    stopTimer() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    timerExit() {
      this.$store.dispatch('AUTH_LOGOUT')
    },
    onClickKey(key) {
      this.updateTimer()
      if (this.number.length < this.fields[this.step].maxLength) {
        this.number = this.number + key
        this.maskedNumber = formatMask(this.number, this.fields[this.step].mask)
      }
    },
    clickBsKey() {
      this.updateTimer()
      this.number = this.number.substring(0, this.number.length - 1)
      this.maskedNumber = formatMask(this.number, this.fields[this.step].mask)
    },
    fwdClick() {
      if (this.fields[this.step].regexp.test(this.number)) {
        if (this.step < this.stepCount - 1) {
          this.updateTimer()
          this.inputs.push(this.number)
          this.step++
          this.number = '';
          this.maskedNumber = formatMask(this.number, this.fields[this.step].mask)
        } else {
          this.stopTimer()
          this.loading = true
          this.$store.dispatch('AUTH_IDENTIFY', {
            phone: this.user ? this.user.phone : null,
            last_name: this.inputs.at(0),
            first_name: this.inputs.at(1),
            middle_name: this.inputs.at(2),
            date_birth: this.inputs.at(3),
            inn: this.isSnils ? undefined : this.inputs.at(4),
            snils: this.isSnils ? this.inputs.at(4) : undefined,
            passport: this.number,
          }).then((res) => {
            console.dir(res)
            this.loading = false
            if (res.status == 1) {
              this.$router.replace('main')
            } else {
              this.messageShow(res.error ?? 'Ошибка запроса')
            }
          }).catch((e) => {
            this.loading = false
            if (e.response !== undefined && e.response.status === 401) {
              this.$store.dispatch('AUTH_LOGOUT')
            } else {
              this.$router.replace('main')
            }
          })
        }
      } else {
        this.messageShow('Проверьте правильность ввода данных')
      }
    },
    backClick() {
      if (this.step > 0) {
        this.updateTimer()
        this.inputs.pop()
        this.step--
        this.number = '';
        this.maskedNumber = formatMask(this.number, this.fields[this.step].mask)
      } else {
        this.stopTimer()
        this.$router.go(-2)
      }
    },
    mainClick() {
      this.stopTimer()
      this.$store.dispatch('AUTH_LOGOUT')
    },
    messageShow(message) {
      this.showMessage = true;
      this.errorMessage = message;
      // Возвращаем Promise, который будет разрешён в messageClose
      return new Promise((resolve) => {
        this.messagePromiseResolver = resolve;
      });
    },
    messageClose() {
      this.showMessage = false;
      this.errorMessage = '';
      // Разрешаем Promise, если он существует
      if (this.messagePromiseResolver) {
        this.messagePromiseResolver();
        this.messagePromiseResolver = null;
      }
    },
    switchInn() {
      this.isSnils = !this.isSnils;
      if (this.isSnils) {
        this.fields[4] = { label: 'Введите ваш СНИЛC', maxLength: 11, mask: '###-###-### ##', regexp: /\d{11}/, keyboardLiteral: false };
      } else {
        this.fields[4] = { label: 'Введите ваш ИНН', maxLength: 12, mask: '###-###-###-###', regexp: /\d{12}/, keyboardLiteral: false };
      }
      this.number = '';
      this.maskedNumber = ''
    }
  }
}
</script>

<style scoped>

</style>
